import React from 'react';

class ArrowIcon extends React.Component {
  render() {
    return this.props.close ? (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.41421 13.4142L7.41421 7.41421C7.80474 7.02369 7.80474 6.39052 7.41421 6L1.41421 0L0 1.41421L5.29289 6.70711L0 12L1.41421 13.4142Z"
          fill="#8A8B8D"
        />
        <path
          d="M8.41421 13.4142L12.1787 9.6497C12.5515 9.27696 12.8731 8.95541 13.1163 8.66891C13.373 8.36651 13.6006 8.03804 13.7318 7.63416C13.9276 7.03163 13.9276 6.38259 13.7318 5.78006C13.6006 5.37617 13.373 5.0477 13.1163 4.74531C12.8731 4.4588 12.5515 4.13725 12.1787 3.76451L8.41421 0L7 1.41421L10.7373 5.15147C11.1449 5.55916 11.4076 5.82294 11.5916 6.03966C11.768 6.24745 11.8126 6.34531 11.8297 6.39809C11.895 6.59893 11.895 6.81528 11.8297 7.01612C11.8126 7.0689 11.768 7.16676 11.5916 7.37455C11.4076 7.59127 11.1449 7.85506 10.7373 8.26274L7 12L8.41421 13.4142Z"
          fill="#8A8B8D"
        />
      </svg>
    ) : (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.46447 0L1.69995 3.76451C1.3272 4.13724 1.00561 4.45881 0.76239 4.74531C0.505679 5.0477 0.278059 5.37617 0.14683 5.78006C-0.0489435 6.38259 -0.0489435 7.03163 0.14683 7.63416C0.278059 8.03804 0.505679 8.36651 0.76239 8.66891C1.00561 8.95541 1.32719 9.27696 1.69995 9.6497L5.46447 13.4142L6.87868 12L3.14142 8.26274C2.73374 7.85506 2.47105 7.59127 2.28707 7.37455C2.11067 7.16676 2.06609 7.0689 2.04894 7.01612C1.98369 6.81528 1.98369 6.59893 2.04894 6.39809C2.06609 6.34531 2.11067 6.24745 2.28707 6.03966C2.47105 5.82294 2.73374 5.55916 3.14142 5.15147L6.87868 1.41421L5.46447 0Z"
          fill="#8A8B8D"
        />
        <path
          d="M12.4645 0L6.46446 6C6.07394 6.39052 6.07394 7.02369 6.46446 7.41421L12.4645 13.4142L13.8787 12L8.58578 6.70711L13.8787 1.41421L12.4645 0Z"
          fill="#8A8B8D"
        />
      </svg>
    );
  }
}

export default ArrowIcon;
